<template>
  <div class="user-create-page">
    <div class="page-header mb-5">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <h1 class="title is-3">Create New User</h1>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <router-link to="/users" class="button is-light">
              <span class="icon">
                <i class="bx bx-arrow-back"></i>
              </span>
              <span>Back to Users</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-8 is-offset-2">
        <div class="card">
          <header class="card-header has-background-primary">
            <p class="card-header-title has-text-white">User Information</p>
          </header>
          <div class="card-content">
            <form @submit.prevent="saveUser">
              <div class="columns">
                <div class="column is-4">
                  <div class="field">
                    <label class="label">First Name*</label>
                    <div class="control">
                      <input 
                        v-model="form.first_name" 
                        class="input" 
                        type="text" 
                        placeholder="Enter first name" 
                        required
                      >
                    </div>
                    <p v-if="errors.first_name" class="help is-danger">{{ errors.first_name }}</p>
                  </div>
                </div>
                <div class="column is-4">
                  <div class="field">
                    <label class="label">Middle Name</label>
                    <div class="control">
                      <input 
                        v-model="form.middle_name" 
                        class="input" 
                        type="text" 
                        placeholder="Enter middle name"
                      >
                    </div>
                    <p v-if="errors.middle_name" class="help is-danger">{{ errors.middle_name }}</p>
                  </div>
                </div>
                <div class="column is-4">
                  <div class="field">
                    <label class="label">Last Name*</label>
                    <div class="control">
                      <input 
                        v-model="form.last_name" 
                        class="input" 
                        type="text" 
                        placeholder="Enter last name" 
                        required
                      >
                    </div>
                    <p v-if="errors.last_name" class="help is-danger">{{ errors.last_name }}</p>
                  </div>
                </div>
              </div>

              <div class="columns">
                <div class="column is-6">
                  <div class="field">
                    <label class="label">Email*</label>
                    <div class="control has-icons-left">
                      <input 
                        v-model="form.email" 
                        class="input" 
                        type="email" 
                        placeholder="Enter email address" 
                        required
                      >
                      <span class="icon is-small is-left">
                        <i class="bx bx-envelope"></i>
                      </span>
                    </div>
                    <p v-if="errors.email" class="help is-danger">{{ errors.email }}</p>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <label class="label">Phone</label>
                    <div class="control has-icons-left">
                      <input 
                        v-model="form.phone" 
                        class="input" 
                        type="tel" 
                        placeholder="Enter phone number"
                      >
                      <span class="icon is-small is-left">
                        <i class="bx bx-phone"></i>
                      </span>
                    </div>
                    <p v-if="errors.phone" class="help is-danger">{{ errors.phone }}</p>
                  </div>
                </div>
              </div>

              <div class="columns">
                <div class="column is-6">
                  <div class="field">
                    <label class="label">Password*</label>
                    <div class="control has-icons-left">
                      <input 
                        v-model="form.password" 
                        class="input" 
                        type="password" 
                        placeholder="Enter password" 
                        required
                      >
                      <span class="icon is-small is-left">
                        <i class="bx bx-lock-alt"></i>
                      </span>
                    </div>
                    <p v-if="errors.password" class="help is-danger">{{ errors.password }}</p>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <label class="label">Confirm Password*</label>
                    <div class="control has-icons-left">
                      <input 
                        v-model="form.password_confirmation" 
                        class="input" 
                        type="password" 
                        placeholder="Confirm password" 
                        required
                      >
                      <span class="icon is-small is-left">
                        <i class="bx bx-lock"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field">
                <label class="label">Address</label>
                <div class="control">
                  <input 
                    v-model="form.address" 
                    class="input" 
                    type="text" 
                    placeholder="Enter address"
                  >
                </div>
                <p v-if="errors.address" class="help is-danger">{{ errors.address }}</p>
              </div>

              <div class="columns">
                <div class="column is-6">
                  <div class="field">
                    <label class="label">City</label>
                    <div class="control">
                      <input 
                        v-model="form.city" 
                        class="input" 
                        type="text" 
                        placeholder="Enter city"
                      >
                    </div>
                    <p v-if="errors.city" class="help is-danger">{{ errors.city }}</p>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <label class="label">Zip Code</label>
                    <div class="control">
                      <input 
                        v-model="form.zip_code" 
                        class="input" 
                        type="text" 
                        placeholder="Enter zip code"
                      >
                    </div>
                    <p v-if="errors.zip_code" class="help is-danger">{{ errors.zip_code }}</p>
                  </div>
                </div>
              </div>

<!--              <div class="field">-->
<!--                <label class="label">Organization*</label>-->
<!--                <div class="control">-->
<!--                  <div class="select is-fullwidth">-->
<!--                    <select v-model="form.organization_id" required>-->
<!--                      <option value="" disabled>Select an organization</option>-->
<!--                      <option v-for="org in organizations" :key="org.id" :value="org.id">{{ org.name }}</option>-->
<!--                    </select>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <p v-if="errors.organization_id" class="help is-danger">{{ errors.organization_id }}</p>-->
<!--              </div>-->

              <div class="field">
                <label class="label">Role</label>
                <div v-if="rolesLoading" class="has-text-centered py-3">
                  <span class="icon is-medium has-text-primary">
                    <i class="bx bx-loader bx-spin"></i>
                  </span>
                  <p class="has-text-grey">Loading roles...</p>
                </div>
                <div v-else-if="roles.length === 0" class="notification is-light is-warning">
                  <p>No roles available. Please create roles first.</p>
                </div>
                <div v-else class="control">
                  <div class="select is-fullwidth">
                    <select v-model="form.role_id">
                      <option value="" disabled>Select a role</option>
                      <option v-for="role in roles" :key="role.id" :value="role.id">{{ role.name }}</option>
                    </select>
                  </div>
                  <p v-if="errors.role_id" class="help is-danger">{{ errors.role_id }}</p>
                </div>
              </div>

              <div class="columns">
                <div class="column is-6">
                  <div class="field">
                    <label class="checkbox">
                      <input type="checkbox" v-model="form.is_active">
                      Active Account
                    </label>
                    <p class="help">If unchecked, user will not be able to login</p>
                  </div>
                </div>
<!--                <div class="column is-6">-->
<!--                  <div class="field">-->
<!--                    <label class="checkbox">-->
<!--                      <input type="checkbox" v-model="form.is_superadmin">-->
<!--                      Super Administrator-->
<!--                    </label>-->
<!--                    <p class="help">Super administrators have access to all system features</p>-->
<!--                  </div>-->
<!--                </div>-->
              </div>

              <div class="field mt-5">
                <div class="control">
                  <button 
                    type="submit" 
                    class="button is-primary is-fullwidth" 
                    :class="{'is-loading': saving}"
                  >
                    Create User
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

export default {
  name: 'UserCreate',
  setup() {
    const router = useRouter()

    const roles = ref([])
    const rolesLoading = ref(true)

    const saving = ref(false)
    const errors = ref({})

    const form = ref({
      first_name: 'John',
      middle_name: 'Michael',
      last_name: 'Rodriguez',
      email: 'john.rodriguez@fastdelivery.com',
      password: 'SecurePass123!',
      password_confirmation: 'SecurePass123!',
      phone: '+1 (555) 234-5678',
      address: '1247 Oak Street, Apt 2B',
      city: 'Sacramento',
      zip_code: '95814',
      is_superadmin: false,
      is_active: true,
      role_id: ''
    })


    const fetchRoles = async () => {
      rolesLoading.value = true
      try {
        const response = await axios.get('/api/roles')
        roles.value = response.data || []

        // Auto-select driver role if available, otherwise select the first role
        const driverRole = roles.value.find(role => role.name?.toLowerCase() === 'driver')
        if (driverRole) {
          form.value.role_id = driverRole.id
        } else if (roles.value.length === 1) {
          form.value.role_id = roles.value[0].id
        }
      } catch (error) {
        console.error('Error fetching roles:', error)
      } finally {
        rolesLoading.value = false
      }
    }

          const selectedRole = computed(() => {
      if (!form.value.role_id) return null
      return roles.value.find(role => role.id === form.value.role_id)
          })

    const saveUser = async () => {
      saving.value = true
      errors.value = {}

      try {
        // Send form data directly - the backend expects role_id
        const userData = { ...form.value }

        await axios.post('/api/users', userData)
        router.push({
          path: '/users',
          query: { success: `User ${form.value.first_name} ${form.value.last_name} created successfully` }
        })
      } catch (error) {
        console.error('Error creating user:', error)
        if (error.response && error.response.data.errors) {
          errors.value = error.response.data.errors
        } else {
          alert('Failed to create user. Please try again.')
        }
      } finally {
        saving.value = false
      }
    }

    onMounted(() => {

      fetchRoles()
    })

    return {
      form,
      roles,
      rolesLoading,
      saving,
      errors,
      saveUser,
      selectedRole
    }
  }
}
</script>

<style scoped>
.user-create-page {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.card {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  overflow: hidden;
}

.card-header {
  border-bottom: none;
}

.card-header-title {
  font-weight: 600;
}

.select select:focus,
.input:focus,
.textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 0.125em rgba(0, 209, 178, 0.25);
}

.checkbox:hover {
  color: var(--primary);
}

.checkbox input {
  margin-right: 0.5rem;
}

.button {
  transition: all 0.2s ease;
}

.button:hover {
  transform: translateY(-2px);
}
</style>
